import { h, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import { DragDropContainerProps } from "../../DragDropContainer/DragDropContainer";
import DragDropContainer from "../../DragDropContainer";

import ReorderListContext from "./ReorderListContext";
import ReorderListData from "./ReorderListData";

import styles from "./ReorderList.module.css";

type InheritedDragDropContainerProps = Pick<DragDropContainerProps,
    "scrollableAreaOffset" |
    "discardScrollableParents" |
    "onStartDrag" |
    "onEndDrag"
>;

interface Props extends InheritedDragDropContainerProps {
    class?: string;
    showDragIcon?: boolean;
    children: ComponentChildren;
    onReorder: (reorderListData: ReorderListData) => void;
}

function ReorderList({
    class: cssClass,
    showDragIcon,
    children,
    onReorder,
    ...dragDropContainerProps
}: Props) {
    return (
        <ReorderListContext.Provider value={{ showDragIcon, onReorder }}>
            <DragDropContainer
                {...dragDropContainerProps}
                class={classname(styles.reorderList, cssClass)}
                itemsClass={styles.reorderListDragDropItems}>
                {children}
            </DragDropContainer>
        </ReorderListContext.Provider>
    );
}

export default ReorderList;
